var _desc, _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconSave(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14px",
    height: "14px",
    viewBox: "0 0 14 14",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Save as PDF") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M13.0833333,3.58333333 C12.9166667,3.41666667 12.75,3.33333333 12.5,3.33333333 L11.6666667,3.33333333 L11.6666667,5.83333333 C11.6666667,6.33333333 11.3333333,6.66666667 10.8333333,6.66666667 L6.66666667,6.66666667 C6.16666667,6.66666667 5.83333333,6.33333333 5.83333333,5.83333333 L5.83333333,3.33333333 L4.16666667,3.33333333 C3.66666667,3.33333333 3.33333333,3.66666667 3.33333333,4.16666667 L3.33333333,15.8333333 C3.33333333,16.3333333 3.66666667,16.6666667 4.16666667,16.6666667 L15.8333333,16.6666667 C16.3333333,16.6666667 16.6666667,16.3333333 16.6666667,15.8333333 L16.6666667,7.5 C16.6666667,7.25 16.5833333,7.08333333 16.4166667,6.91666667 L13.0833333,3.58333333 Z M13.3333333,11.6666667 C13.8333333,11.6666667 14.1666667,12 14.1666667,12.5 L14.1666667,15 L5.83333333,15 L5.83333333,12.5 C5.83333333,12 6.16666667,11.6666667 6.66666667,11.6666667 L13.3333333,11.6666667 Z M10.8333333,3.33333333 L10.8333333,5.83333333 L9.16666667,5.83333333 L9.16666667,3.33333333 L10.8333333,3.33333333 Z",
    id: "path-1-icon-save"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "GLOBAL---COMMUNICATIONS",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Communications---Letter-Builder---Letter-Preview",
    transform: "translate(-1178.000000, -59.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Dialog",
    transform: "translate(29.000000, 28.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(1138.000000, 20.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Button/Icon-Copy"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon/Save",
    transform: "translate(8.000000, 8.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2-icon-save",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1-icon-save"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Mask",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Mixin/Fill/Black",
    mask: "url(#mask-2-icon-save)",
    fill: "#00242D",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }))))))))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSave);
export default __webpack_public_path__ + "static/media/icon-save.34b7bc1d.svg";
export { ForwardRef as ReactComponent };